import { render, staticRenderFns } from "./18introduce.vue?vue&type=template&id=d7e9b824&scoped=true&"
import script from "./18introduce.vue?vue&type=script&lang=js&"
export * from "./18introduce.vue?vue&type=script&lang=js&"
import style0 from "./18introduce.vue?vue&type=style&index=0&id=d7e9b824&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d7e9b824",
  null
  
)

export default component.exports